export default __webpack_public_path__ + "static/phone-map-mobile-ca6a125c096e0306290b61484f1c4a54.png";